import { observer } from 'mobx-react-lite';
import * as React from 'react';
import ComposeActionButton from 'owa-calendar-quick-compose-view/lib/components/ComposeActionButton';
import updateContentToViewState from 'owa-editor/lib/utils/updateContentToViewState';
import { verifyEventThenSave } from 'owa-calendar-compose-form-actions';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { sendButtonLabel } from 'owa-locstrings/lib/strings/sendbuttonlabel.locstring.json';
import { saveButtonLabel } from 'owa-locstrings/lib/strings/savebuttonlabel.locstring.json';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import { getComposeEvent, getFullComposeViewState } from 'owa-calendar-compose-store-manager';

const styles = require('./ComposeSendSaveButton.scss');

export interface ComposeSendSaveButtonProps {
    formId: string | null;
}

const ComposeSendSaveButton = observer(function ComposeSendSaveButton(
    props: ComposeSendSaveButtonProps
) {
    const { formId } = props;

    const event = getComposeEvent(formId);
    const colorScheme = getComposeCalendarColorScheme(formId);
    const fullComposeViewState = getFullComposeViewState(formId);
    const disabled = !fullComposeViewState.uiEnabled;

    if (
        isFeatureEnabled('mon-cal-saveButtonInlineInEdit') &&
        isHostAppFeatureEnabled('saveInFullCompose')
    ) {
        const onSaveOrSend = () => {
            updateContentToViewState(fullComposeViewState?.bodyViewState);
            verifyEventThenSave();
        };

        if (isEventAMeeting(event)) {
            return (
                <ComposeActionButton
                    icon={ControlIcons.Send}
                    colors={colorScheme}
                    id={loc(sendButtonLabel)}
                    className={styles.saveButton}
                    caption={loc(sendButtonLabel)}
                    onClick={onSaveOrSend}
                    disabled={disabled}
                />
            );
        } else {
            return (
                <ComposeActionButton
                    icon={ControlIcons.Save}
                    colors={colorScheme}
                    id={loc(sendButtonLabel)}
                    className={styles.saveButton}
                    caption={loc(saveButtonLabel)}
                    onClick={onSaveOrSend}
                    disabled={disabled}
                />
            );
        }
    }
    return <div className={styles.saveButtonHidden} />;
});

export default ComposeSendSaveButton;
